import type { Shape } from "../adapters/types";

export type LinkedContentResolver = (shape: Shape, source: string) => string | undefined;

/**
 * Remplace, pour l'affichage, le texte et l'image reliés d'une forme (`ShapeText.source`,
 * `ShapeImage.source`) par leur valeur actuelle chez le consommateur. La forme du store n'est pas
 * modifiée : seule la copie passée à l'adapter l'est.
 *
 * Une image reliée qui change de `src` perd `width`/`height`/`svg`, qui décrivaient l'ancienne : ils
 * seront sondés de nouveau. Une valeur vide pour une image la retire.
 */
export function applyLinkedContent(shape: Shape, resolve?: LinkedContentResolver): Shape {
  if (!resolve) return shape;

  let result = shape;

  const text = shape.text;
  if (text?.source) {
    const value = resolve(shape, text.source);
    if (value !== undefined && value !== text.text) result = { ...result, text: { ...text, text: value } };
  }

  const image = shape.image;
  if (image?.source) {
    const src = resolve(shape, image.source);
    if (src === "") result = { ...result, image: undefined };
    else if (src !== undefined && src !== image.src) {
      const { width: _width, height: _height, svg: _svg, ...rest } = image;
      result = { ...result, image: { ...rest, src } };
    }
  }

  return result;
}
